module.exports = __webpack_public_path__ + "img/loader.1b54d424.webp";